import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { UserService } from '../service/user/user.service';
import { AuthUtils } from './auth.utils';
import { environment as env } from 'src/environments/environment';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'jquery';

@Injectable()
export class AuthService
{
    public _authenticated: boolean = false;
    public _installerauthenticated: boolean = false;
    private _basePath = env.url + env.api_auth;
    private url_desktop = env.url_desk;
    private url_sell = env.url_sell;
    private sellerUrl = env.url;
    private sellerApi = env.api_sell;
    public flag_redirect : boolean = false;
    public flag_licenses : boolean = false;
    public url_redirect: string = '';

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private _router: Router
    )
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set access_token(token: string)
    {
        localStorage.setItem('access_token_web', token);
    }

    get access_token(): string
    {
        return localStorage.getItem('access_token_web') ?? '';
    }

    set refresh_token(token: string)
    {
        localStorage.setItem('refresh_token_web', token);
    }

    get refresh_token(): string
    {
        return localStorage.getItem('refresh_token_web') ?? '';
    }

    get is_authenticated(): boolean
    {
        return this._authenticated;
    }

    get is_installer():boolean{
        return this._installerauthenticated;
    }

    get permission_user():string {

        return localStorage.getItem('permission_user') ?? '';
    }

    set permission_user(permission: string)
    {
        switch(permission){
            case 'solf_kernel.is_installer':
                localStorage.setItem('permission_user', 'installer');
                break;

            case 'solf_kernel.is_seller':

                localStorage.setItem('permission_user', 'seller');
                break;

            case 'solf_kernel.is_corporative_seller':

                localStorage.setItem('permission_user', 'corporative_seller');
                break;

            case 'solf_kernel.is_employee':

                localStorage.setItem('permission_user', 'employee');
                break;

            default:
                localStorage.setItem('permission_user', '');
                break;

        }

    }

    get allowed_pages()
    {
        return JSON.parse(localStorage.getItem('allowed_pages'));
    }

    set is_associated_user(isAssociatedUser: any) {
        localStorage.setItem('is_associated_user', isAssociatedUser);
    }

    get is_associated_user(): string {
        return localStorage.getItem('is_associated_user') ?? '';
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any>
    {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('User is already logged in.');
        }
        else if ( this._installerauthenticated )
        {
            return throwError('User is already logged in.');
        }

        let headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "*/*",
        });

        let data = "username=" + credentials.email + "&password=" + encodeURIComponent(credentials.password) + "&grant_type=password&" +
          "client_secret=" + env.client_secret + "&client_id=" + env.client_id + "&loginOrigin=web&platform=dashboard_zero";

        return this._httpClient.post(this._basePath + 'o/token/', data, { 'headers': headers }).pipe(
            switchMap((response: any) => {
                this.access_token = response.access_token;
                this.refresh_token = response.refresh_token;
                this.is_associated_user = response?.isAssociatedUserLogin || false;
                // localStorage.setItem('access_token_web',this.access_token)
                // localStorage.setItem('refresh_token_web',this.refresh_token)
                // Store the user on the user service

                // this.check_login_page_redirect();
                return of(true)

                // return this.getAllowedPages().pipe(
                //     tap((permissions) => {
                //         localStorage.setItem('allowed_pages', JSON.stringify(permissions.pages));
                //     }),
                //     map(() => response)
                // );
            }),
            catchError((error) => {
                // console.error('Error during sign-in:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {
        let headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json",
          });

        let data = "grant_type=refresh_token&" +
        "client_secret=" + env.client_secret + "&client_id=" + env.client_id +
        "&refresh_token=" + this.refresh_token + "&loginOrigin=web&platform=dashboard_zero";
        // Renew token
        return this._httpClient.post(this._basePath + 'o/token/', data, { 'headers': headers }).pipe(
            catchError(() =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {
                this.access_token = response.access_token;
                this.refresh_token = response.refresh_token;
                this.is_associated_user = response?.isAssociatedUserLogin || false;
                // localStorage.setItem('access_token_web',this.access_token)
                // localStorage.setItem('refresh_token_web',this.refresh_token)
                // Store the user on the user service


                //this.check_login_page_redirect();
                return of(true)

                // Return true
                // return this.getAllowedPages().pipe(
                //     tap((permissions) => {
                //         localStorage.setItem('allowed_pages', JSON.stringify(permissions.pages));
                //     }),
                //     map(() => true)
                // );
            })
        );
    }

    check_login_page_redirect()
    {
        // console.log('check_login_page_redirect');

        // if (this.check_is_corporative() && this._router.url == '/login'  ) {
        //     console.log(this.check_is_corporative());

        //     console.log('check_is_corporative');
        //     this._router.navigateByUrl('/dashboard');
        // }
        // // else if (this.check_is_installer() && this._router.url == '/login'  ) {
        // //     this._router.navigateByUrl('/init_installer');
        // // }
        // console.log('redirect to login');
        // this._router.navigateByUrl('/login');
        if ( this._router.url == '/login'  )
        {
            this.redirect_user();
        }

    }

    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        // this._authenticated = false;
        // this._installerauthenticated = false;
        this.clean_token()

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.access_token )
        {
            return of(false);
        }

        // Check the access token expire date
        // We don't use it because our current Bearer token is not AWT compatible.
        if ( false && AuthUtils.isTokenExpired(this.access_token) )
        {
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        return this.signInUsingToken();

    }

    /**
     * Check the authentication status
     */
    check_is_corporative(): Observable<boolean>
    {
        // Check the access token availability
        if ( !this.access_token )
        {
            this._router.navigateByUrl('/login');
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        this.signInUsingToken();
        this.get_permission_user();

        if (this.permission_user == 'corporative_seller')
        {
            return of(true);
        }
        else{
            return of(false);
        }

    }

    check_is_installer(): Observable<boolean>
    {
        // Check the access token availability
        if ( !this.access_token )
        {
            this._router.navigateByUrl('/login');
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        this.signInUsingToken();

        this.get_permission_user();

        if (this.permission_user == 'installer')
        {
            return of(true);
        }
        else{
            return of(false);
        };
    }


    /**
     * Get user permission
     *
     */
    get_permission_user()
    {

        let headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "*/*",
        });

        return this._httpClient.get(this._basePath + 'detail_permission/', { 'headers': headers }).pipe(
            switchMap((response: any) => {
                this.permission_user = response[0];
                return of(true);
            }),
            catchError((error) =>{
                this.clean_token();
                return of(false);
            })
        );
    }

    /**
     * Get user allowed pages
     *
     */
    getAllowedPages(): Observable<any> {
        return this._httpClient.get(this.sellerUrl + this.sellerApi + 'auth/seller/licenses/');
    }

    /**
     * Redirect user
     *
     */
    redirect_user()
    {
        switch(this.permission_user){
            case 'installer':
                this._router.navigateByUrl('/dashboard-project-detail-inst');
                break;

            case 'corporative_seller':
                this.getAllowedPages().subscribe((resp) =>{
                    localStorage.setItem('allowed_pages', JSON.stringify(resp.pages));
                    this._router.navigateByUrl('/dashboard');

                },(error) => {
                    // Manejo de error
                    console.error('Error al obtener datos:', error.error.errors[0]['text']);
                    this.flag_licenses = true;
                  },);
                break;

            case 'employee':
                this.clean_token();
                this.flag_redirect = true;
                this.url_redirect = this.url_desktop
                break;

            case 'seller':
                this.clean_token();
                this.flag_redirect = true;
                this.url_redirect = this.url_sell
                break;

            default:
                this.clean_token();
                this._router.navigateByUrl('/login');
                break;

        }
    }

    /**
     * Clean token and redirect login
     *
     */
    clean_token()
    {
        this.flag_redirect = false;
        this.access_token = '';
        this.refresh_token = '';
        this.permission_user = '';
        this.is_associated_user = false;
        localStorage.setItem('access_token_web',this.access_token);
        localStorage.setItem('refresh_token_web',this.refresh_token);
        localStorage.setItem('permission_user',this.permission_user);
        localStorage.removeItem('is_associated_user');
    }
}
